module.exports = __webpack_public_path__ + "img/topicSustainability.d1885b29.svg";